import { isArray, isNumber } from '@beeline.com/bp-design-system';
import { ExportSource, type MappedNotification } from 'common/header/notifications/Notifications.types';

export type KnownMetadataKeys =
  | 'COUNT'
  | 'ACTUAL_COUNT'
  | 'ZERO_ALLOCATIONS_COUNT'
  | 'SOURCE_TYPE'
  | 'NAME'
  | 'ENTITY_TYPE'
  | 'REPORT_NAME'
  | 'IMPORTER_STARTED_AT'
  | 'IMPORTER_FINISHED_AT'
  | 'PROCESSED_RECORD_COUNT'
  | 'FAILED_RECORD_COUNT'
  | 'STATUS'
  | 'SUBJECT'
  | 'BODY'
  | 'targetWorkerQualificationUid'
  | 'targetPersonUid'
  | 'IMPORTER_ENTITY_TYPE';
export type KnownNumberMetadataKeys = Extract<KnownMetadataKeys, 'COUNT' | 'ACTUAL_COUNT' | 'ZERO_ALLOCATIONS_COUNT'>;

export const getMetaData = (notification: MappedNotification) => {
  const metadata = notification && isArray(notification?.metadata) ? notification.metadata : [];
  return {
    items: metadata,
    entityType: metadata.find((e) => e?.key === 'ENTITY_TYPE')?.value?.toLocaleLowerCase() as ExportSource | undefined,
    item: (key: KnownMetadataKeys | string) => {
      return metadata.find((e) => e?.key === key);
    },
    value: (key: KnownMetadataKeys | string): string | undefined => {
      return metadata.find((e) => e?.key === key)?.value ?? undefined;
    },
    numberValue: (key: KnownNumberMetadataKeys) => {
      const value = metadata.find((e) => e?.key === key)?.value;
      const parsedValue = !!value ? parseInt(value, 10) : null;
      return isNumber(parsedValue) ? parsedValue : null;
    }
  };
};
